require("./bootstrap");
import Vue from "vue";
window.Vue = Vue;

import { BootstrapVue } from "bootstrap-vue";
import vClickOutside from "v-click-outside";
import auth from "./mixins/auth.js";
import Toasted from 'vue-toasted';
import VueApexCharts from "vue-apexcharts";
import LoadingMessage from './views/LoadingMessage.vue';
Vue.mixin(auth);
Vue.use(Toasted, {
        duration: 1000
    });
Vue.prototype.$isDev = process.env.MIX_APP_ENV !== "production";
Vue.config.devtools = Vue.prototype.$isDev;
Vue.config.debug = Vue.prototype.$isDev;
Vue.config.silent = !Vue.prototype.$isDev;

Vue.use(BootstrapVue);
Vue.use(vClickOutside);
Vue.component(
    "dynamic-component",
    require("./components/dynamic-component").default
);
Vue.component("apexchart", VueApexCharts);
Vue.component('loading-message', LoadingMessage);
import "./views";
const app = new Vue({
    el: "#app",
    data() {
        return {
            layoutType: "vertical"
        };
    },
    created() {
        // const layout = localStorage.getItem("layout-type");
        // if (layout) {
        //     this.layoutType = layout;
        // }
    },
    methods: {
        // changeMode(mode) {
        //     let cssUrl = document.getElementById("layout-css").href;
        //     cssUrl = cssUrl.split("/");
        //     cssUrl.pop();
        //     document.cookie = "layout=" + (mode || "default");
        //     switch (mode) {
        //         case "dark":
        //             cssUrl.push("app-dark.css");
        //             break;
        //         default:
        //             cssUrl.push("app.css");
        //             break;
        //     }
        //     document.getElementById("layout-css").href = cssUrl.join("/");
        // },
        // changeLayout(layout) {
        //     this.layoutType = layout;
        //     localStorage.setItem("layout-type",  layout);
        // }
    }
});
